import * as React from 'react';
import HelpDocument from '../../models/helpDocument';
import ReportToolbar from './report-toolbar';
import * as styles from './report.module.scss';
import { DashboardReport, TableauToken } from '../dashboard/dashboard-view';

interface Props {
  url: string;
  documents: HelpDocument[];
  options: any;
  isInteractive: boolean;
  viz: any;
  setViz: React.Dispatch<any>;
  // metadata about the report page
  reportMeta: DashboardReport;
  tableauToken: TableauToken;
}

/**
 * Component to render the tableau toolbar and a container for the viz iframe, and initialize the viz
 */
const TableauReport = ({ url, documents, options, isInteractive, viz, setViz, reportMeta, tableauToken }: Props) => {
  const [fullscreen, setFullscreen] = React.useState<boolean>(false);
  const reportRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (viz === null) {
      initTableau();
    }

    const handleFullscreen = () => setFullscreen(!!document.fullscreenElement);

    /** Adds event listener to detect full screen mode */
    window.addEventListener('fullscreenchange', handleFullscreen);
    return function cleanup() {
      window.removeEventListener('fullscreenchange', handleFullscreen);
    };
  }, []);

  const initTableau = () => {
    // In case tableau has yet to bind to the window, set a timer for this function to re-run
    if (document.getElementById('tableau-viz') === undefined) {
      setTimeout(() => {
        initTableau();
      }, 100);
      return;
    }

    setViz(document.getElementById('tableau-viz'));
  };

  return (
    <div ref={reportRef} className={fullscreen ? styles.fullscreenContainer : ''}>
      <ReportToolbar
        viz={viz}
        documents={documents}
        container={reportRef && reportRef.current}
        isInteractive={isInteractive}
        reportName={reportMeta.name}
      />
      {/* This removes the fixed height of the toolbar */}
      <div style={{ height: 'calc(100vh - 37px)', minHeight: fullscreen ? 'calc(100vh - 37px)' : 'calc(100vh - 200px)' }}>
        {/* @ts-ignore */}
        <tableau-viz
          id="tableau-viz"
          src={url}
          token={tableauToken.token}
          width="100vw"
          height="100vh"
          toolbar="hidden"
        />
      </div>
    </div>
  );
};

export default TableauReport;
